module.exports = __webpack_public_path__ + "awesome-shopping-cart.b42573ed95b1559dee83.svg";


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/assets/images/awesome-shopping-cart.svg
// module id = ../../../../../src/assets/images/awesome-shopping-cart.svg
// module chunks = 2